/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useModal } from '../../../contexts/ModalContext'
import Modal from '../../Modal'
import AckViewDocDialog from '../../AckViewDocDialog'
import type { EosTask } from './types'
import styled from 'styled-components'

const btnMinWidth = '100px'

const CustomModalBody = styled.div`
  padding: 10px 15px 30px !important;
`

interface AckCompletedDialogProps {
  task: EosTask
  onClose?: () => void
}

const AckCompletedDialog: React.FC<AckCompletedDialogProps> = ({ task, onClose }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const { showModal } = useModal()

  useEffect(() => {
    setIsOpen(true)
  }, [])

  const doClose = (isTerminateFlow: boolean) => {
    setIsOpen(false)
    if (onClose && isTerminateFlow) {
      onClose()
    }
  }

  return (
    <Modal
      show={isOpen}
      handleClose={() => doClose(true)}
      title={t('EOS_DASHBOARD_TASK_ACKNOWLEDGEMENT_COMPLETED_TITLE')}
      className="eos-complete-ack-task-modal"
      size="md"
    >
      <Modal.Body>
        <CustomModalBody>
          <div>
            <b>{t('EOS_DASHBOARD_TASK_ACKNOWLEDGEMENT_COMPLETED_MSG')}</b>
          </div>
          <div className="d-flex mt25">
            <div className="d-flex">
              <button
                style={{ minWidth: btnMinWidth }}
                className="btn btn-primary text-capitalize mr10"
                onClick={() => {
                  doClose(false)
                  showModal(
                    <AckViewDocDialog
                      pdfSrc={task.pdfSrc as unknown as React.ComponentProps<typeof AckViewDocDialog>['pdfSrc']}
                      pdfInfo={task.pdfInfo}
                      thumbnailId={task.thumbnailId}
                      downloadFn={task.downloadFn}
                      onClose={onClose}
                    />
                  )
                }}
                id="8b1c39d1-b726-4ef3-9a6f-fe91fd0cbac3"
              >
                {t('EOS_DASHBOARD_TASK_COMPLETED_VIEW_BTN')}
              </button>
              <button
                style={{ minWidth: btnMinWidth }}
                className="btn btn-primary text-capitalize mr10"
                onClick={task.downloadFn}
                id="21523acb-399b-425b-99ca-803655501ecc"
              >
                {t('EOS_DASHBOARD_TASK_COMPLETED_DOWNLOAD_BTN')}
              </button>
            </div>
          </div>
        </CustomModalBody>
      </Modal.Body>
    </Modal>
  )
}

export default AckCompletedDialog
